import axios from "axios";

export default {
  async getEtudiant() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants/monprofil"
    );
    return response.data;
  },
  async getUserAttributes() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/users/monprofil"
    );
    return response.data;
  },
  async addEtudiant(etudiant) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants",
      etudiant
    );
    return response.data;
  },
  async updateEtudiant(etudiant) {
    const response = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants",
      etudiant
    );
    return response.data;
  },
  async getSeriesBac() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/seriesBac"
    );
    return response.data;
  },
  async getMesPiecesEtudiantFormation(idFormation) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/etudiants/formations/" +
        idFormation +
        "/pieces"
    );
    return response.data;
  },
  async getPiecesEtudiantFormation(idEtudiant, idFormation) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/gestion/etudiants/" +
        idEtudiant +
        "/formations/" +
        idFormation +
        "/pieces"
    );
    return response.data;
  },
  async depotPieceEtudiant(idTypePiece, idFormation, formData) {
    const headers = {
      "Content-Type": "multipart/form-data"
    };
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/etudiants/typesPieces/" +
        idTypePiece +
        "/formation/" +
        idFormation,
      formData,
      {
        headers: headers
      }
    );
    return response.data;
  },
  async getMonFichierPieceEtudiant(idPiece) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants/pieces/" + idPiece
    );
    return response.data;
  },
  async getFichierPieceEtudiant(idEtudiant, idPiece) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/gestion/etudiants/" +
        idEtudiant +
        "/pieces/" +
        idPiece
    );
    return response.data;
  },
  async isReorientationOuverte() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants/reorientation"
    );
    return response.data;
  },
  async getEtudiantAtelier() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants/atelier"
    );
    return response.data;
  },
  async desinscrireEtudiantAtelier(idAtelier) {
    await axios.post(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/etudiants/desinscription/ateliers/" +
        idAtelier
    );
  },
  async inscrireEtudiantAtelier(idAtelier, idFormation) {
    await axios.post(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/etudiants/inscription/ateliers/" +
        idAtelier +
        "/formations/" +
        idFormation
    );
  },
  async getInscritsAtelier(idAtelier) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/etudiants/ateliers/" +
        idAtelier
    );
    return response.data;
  },
  async setEmargementAtelier(etudiants) {
    const response = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants/presenceAtelier",
      etudiants
    );
    return response.data;
  },
  async getPresencesEtudiant() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants/etudiant/presences"
    );
    return response.data;
  },
  async getNiveauxEtude() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/etudiants/niveauxEtude"
    );
    return response.data;
  }
};
